export default "__VITE_ASSET__Cm6zU9kr__"